const MATERIAL_LABEL_MAP = {
  Copper: 'Copper enhanced Ceramic',
  'Copper-free': 'Copper free ceramic',
};

export const formatMaterial = (material) => {
  if (typeof material !== 'string') return material;
  return MATERIAL_LABEL_MAP[material] || material;
};

export const normalizeMaterial = (material) => {
  if (typeof material !== 'string') return material;
  return MATERIAL_LABEL_MAP[material] || material;
};
